import { inject, Injectable } from '@angular/core';
import { ApiRouteMoldRevisionService } from '../../../api/elite/routes/mold-revision.service';
import { ApiRouteMachinesService } from '../../../api/elite/routes/machines.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Machine } from '../../../api/elite/types/machine';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';
import { MoldRevisionItem } from '../../../common/mold/models/item';

@Injectable()
export class MoldViewApiService {
  private readonly departmentService = inject(SingleDepartmentService);
  private readonly moldApiRouter = inject(ApiRouteMoldRevisionService);
  private readonly machineApiRouter = inject(ApiRouteMachinesService);

  getMolds(): Observable<MoldRevisionItem[]> {
    return this.moldApiRouter
      .getMoldsByDepartment(this.departmentService.NAME)
      .pipe(map((res) => res.map((mold) => MoldRevisionItem.fromObject(mold))));
  }

  getMachines(): Observable<Machine[]> {
    return this.machineApiRouter.getAll({
      departmentName: this.departmentService.NAME,
    });
  }
}
